:global([data-sonner-toaster]) {
	padding-left: 0;
	list-style: none;
}

:global([data-sonner-toast]) {
	list-style: none;
}

.toast {
	display: flex;
	align-items: center;
	gap: 12px;

	width: 100%;
	min-width: 320px;
	padding: 12px 16px;

	background-color: var(--background-secondary);
	border-radius: 8px;
	box-shadow: var(--box-shadow);
}

.title {
	flex: 1;
	min-width: 0;
	color: var(--content-secondary);
}

.iconBadge {
	display: inline-flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;

	width: 20px;
	height: 20px;

	border-radius: 50%;
	color: var(--content-secondary);
}

.iconBadgeSuccess {
	background-color: var(--content-success);
}

.iconBadgeInfo {
	background-color: var(--content-info);
}

.iconBadgeError {
	background-color: var(--content-error);
}
